import React from 'react';
import Breadcrumb from '../components/layout/Breadcrumb';
import Seo from '../components/Seo';
import AboutBanner from '../components/about/AboutBanner';
import CoreValues from '../components/about/CoreValues';
import Vision from '../components/about/Vision';
import Mission from '../components/about/Mission';
import QuoteBanner from '../components/about/QuoteBanner';
import IntroStats from '../components/about/IntroStats';
import CertificateSection from '../components/about/CertificateSection';

const AboutPage = () => {
  return (
    <>
      <Seo
        title="About Us | PVS Harness Solution"
        description="Learn about PVS Harness Solution's manufacturing capabilities, experience, and quality standards in wire harness assembly for automotive, electrical, and industrial sectors."
        path="/about"
        schema={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://pvsharness.com/" },
            { "@type": "ListItem", "position": 2, "name": "About Us", "item": "https://pvsharness.com/about" }
          ]
        }}
      />

      <Breadcrumb
        heading="About Us"
        links={[
          { label: "Home", url: "/" },
          { label: "About Us" }
        ]}
      />

      <IntroStats/>

      <Mission/>
      <Vision/>
      <AboutBanner/>
      <CoreValues/>
      <CertificateSection/>

      <QuoteBanner/>
    </>

  );
};

export default AboutPage;